# GDPR Policy for Safe Learning Management System

## 1\. Introduction

This GDPR Policy outlines how Safe Asset Group International AB ("we", "us", or "our") complies with the General Data Protection Regulation (GDPR) in relation to the Safe Learning Management System. This policy should be read in conjunction with our Privacy Policy.

## 2\. Data Controller

Safe Asset Group International AB acts as the data controller for personal data collected through the Safe Learning Management System. Our contact details are:

Safe Asset Group International AB  
Kivra: 559072-8746  
106 31 Stockholm  
Sweden

Email: [info@safeassetgroup.com](mailto:info@safeassetgroup.com)  
Phone: \+46 31 201 000

## 3\. Lawful Basis for Processing

We process personal data on the following lawful bases:

* Consent: For users who provide their name and email to access the Service Administrative Portal.  
* Legitimate Interests: For processing usage data to improve our service.

## 4\. Data Subject Rights

Under GDPR, you have the following rights:

1. Right to be informed  
2. Right of access  
3. Right to rectification  
4. Right to erasure ('right to be forgotten')  
5. Right to restrict processing  
6. Right to data portability  
7. Right to object  
8. Rights related to automated decision making including profiling

To exercise these rights, please contact us using the details provided in Section 2\.

Note: For users who only access courses by distributed codes, no direct personally identifiable information is collected. Neither do we collect enough other information granular enough to single out a specific individual. Thus we are unable to process Data Subject Rights Requests for these users.

## 5\. International Data Transfers

We store all data on secure servers located in the European Union. In the event that we need to transfer data outside the EU/EEA, we will ensure that appropriate safeguards are in place in accordance with GDPR requirements.

## 6\. Data Retention

We retain personal data for as long as necessary to provide our services or as required by law. Specific retention periods are outlined in our Privacy Policy.

## 7\. Data Breach Notification

In the event of a personal data breach, we will notify the relevant supervisory authority within 72 hours of becoming aware of the breach, where feasible. If the breach is likely to result in a high risk to your rights and freedoms, we will also notify affected individuals without undue delay.

## 8\. Data Protection Impact Assessment (DPIA)

We conduct DPIAs for any high-risk data processing activities as required by the GDPR.

## 9\. Privacy by Design and Default

We implement appropriate technical and organisational measures to ensure that, by default, only personal data necessary for each specific purpose of processing is processed.

## 10\. Records of Processing Activities

We maintain records of our processing activities as required by Article 30 of the GDPR.

## 11\. Changes to this GDPR Policy

We may update this GDPR Policy from time to time. We will notify you of any significant changes by posting the new policy on our website.

## 12\. Complaints

If you have concerns about our data processing activities, please contact us first so that we can address your concerns. You also have the right to lodge a complaint with a supervisory authority in the EU member state of your habitual residence, place of work, or place of the alleged infringement.

Last updated: 2024-09-05

